// extracted by mini-css-extract-plugin
export default {"LoaderWrapper":"Loader_LoaderWrapper__uWs9f","loader":"Loader_loader__R-+Sf","box":"Loader_box__QoaLf","ripple":"Loader_ripple__0fdd3","logo":"Loader_logo__LHJLo"};